import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Slider } from '@material-ui/core';


import FilterWrapper from '../filter-wrapper';

class SessionLengthFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sessionLength: props.filterOptions.sessionLength ? props.filterOptions.sessionLength.asMutable() : [0, 0],
    };
  }

  componentWillUnmount() {
    this.reset();
  }

  handleChange = (_, value) => {
    this.setState({
      sessionLength: value,
    });
  }

  handleChangeCommitted = (_, value) => {
    const { setFilterOption } = this.props;

    // reset the filter if start and end are the same
    if (value[0] === value[1]) {
      setFilterOption({ key: 'sessionLength', value: null });
    } else {
      setFilterOption({ key: 'sessionLength', value });
    }
  }

  reset = () => {
    const { setFilterOption } = this.props;

    setFilterOption({ key: 'sessionLength', value: null });
    this.setState({
      sessionLength: [0, 0],
    });
  }

  render() {
    const { sessionLength } = this.state;

    return (
      <FilterWrapper title="Sessionlänge" resetFilter={this.reset}>
        <Slider
          value={sessionLength}
          onChange={this.handleChange}
          onChangeCommitted={this.handleChangeCommitted}
          step={30}
          max={60 * 24}
          valueLabelDisplay="auto"
          valueLabelFormat={x => `${x / 60}h`}
        />
      </FilterWrapper>
    );
  }
}

SessionLengthFilter.propTypes = {
  filterOptions: PropTypes.object,
  setFilterOption: PropTypes.func,
};

SessionLengthFilter.defaultProps = {
  filterOptions: null,
  setFilterOption: () => {},
};

export default SessionLengthFilter;
